import { appEntry } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-950 to-background-800 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-3">
                <i className="ri-smartphone-line text-accent-500 mr-2"></i>
                {appEntry.title}
              </h2>
              <p className="text-sm md:text-base text-background-300/80 leading-relaxed mb-5 max-w-[480px] mx-auto lg:mx-0">
                {appEntry.desc}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-5">
                {appEntry.features.map((f) => (
                  <span
                    key={f}
                    className="px-4 py-2 bg-background-50/10 text-background-200 text-sm rounded-full border border-background-50/15 whitespace-nowrap"
                  >
                    <i className="ri-check-line mr-1.5 text-accent-500"></i>
                    {f}
                  </span>
                ))}
              </div>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-950 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                了解更多
              </a>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="aspect-[9/16] rounded-2xl bg-background-700/50 border border-background-50/10 overflow-hidden">
                <div className="h-full flex flex-col items-center justify-center gap-3 text-background-300/50">
                  <i className="ri-smartphone-line text-5xl"></i>
                  <span className="text-xs">移动端体验</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}